import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GetSituViewRequest, GetSituViewResponse, SituViewWebApiClient } from 'situview-webapi-client';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'situ-plan-readonly',
  templateUrl: './situ-plan-readonly.component.html',
  styleUrls: ['./situ-plan-readonly.component.scss']
})
export class SituPlanReadonlyComponent implements OnInit, AfterViewInit {
  @Input() routeParams: any;
  
  /* view high level controls */
  paramId: string | undefined;
  url: string | undefined;
  urlIos: string | undefined;

  /* view data */
  productWidth: number | undefined;
  linkToPortal: string | undefined;

  @ViewChild('modelContainer') modelContainer: ElementRef | undefined;

  constructor(
    private snackBar: MatSnackBar,
    private configService: ConfigService,
    private situView: SituViewWebApiClient) {}

  ngOnInit(): void {
    if (this.routeParams['id']) {
      this.paramId = this.routeParams['id'];
      this.url = `${this.configService.config.situViewWebApiBaseUrl}/home/getglb?artifactId=${this.routeParams['id']}&fileName=home.glb`;
      this.urlIos = `${this.configService.config.situViewWebApiBaseUrl}/home/getglb?artifactId=${this.routeParams['id']}&fileName=home.usdz`;
    }
  }

  ngAfterViewInit(): void {
    if (this.paramId) {
      this.getHomeById(this.paramId);
    }
  }

  openInPortal() {
    window.open(this.linkToPortal, '_blank');
  }

  private getHomeById(artifactId: string) {
    let request = new GetSituViewRequest();
    request.renderedOutputId = artifactId;

    return this.situView.getSituView(request)
      .then((response: GetSituViewResponse) => {
        if (response.success && response?.files?.length && response.files.length > 0) {
          this.linkToPortal = `${this.configService.config.situPortalBaseUrl}/situ-view?id=${this.paramId}`;
        }
      })
      .catch((err: any) => {
        //this.showMessage("Sorry! There was an issue at our end retrieving your render. Please try again.");
      })
      .finally(() => {
        //this.loading = false;
      });
  }

  private showMessage(message: string) {
    this.snackBar.open(message, 'OK', { duration: 2000 });
  }
}